// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { useFormik } from 'formik';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Link, useParams } from 'react-router-dom';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../../components/Section';
import ContentBlock from '../../../components/ContentBlock';
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import SelectBlock from '../../../components/SelectBlock';
import InputBlock from '../../../components/InputBlock';
import Button from '../../../components/Button';
// PARTIALS
// SERVICES AND HELPERS
import * as confirmModal from '../../../../redux/confirmModalRedux';
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as jobFormService from '../../../../services/service/jobFormService';
import * as helper from '../../../../helpers/helper';
import * as leadInfoSheetService from '../../../../services/form/leadInfoSheetService';
import LeadInfoSheetValidator from '../../../../helpers/validators/LeadInfoSheetValidator';
import LeadInfoSheetLineItemValidator from '../../../../helpers/validators/LeadInfoSheetLineItemValidator';

const initialState = {
    id: 0,
    projectLocationId: null,
    contractor: '',
    contractorPhoneNumber: '',
    contractorAddress: '',
    abatedAmountAndType: '',
    leadBasedPaintPercentage: '',
    blasting: '',
    typeOfBlastMedia: '',
    powerTooling: '',
    handTooling: '',
    enclosureMaterial: '',
    enclosureType: '',
    typeOfVentilation: '',
    elevationOfProject: '',
    levelOfElevation: '',
    typeOfDecontaminationUnit: '',
    deconLocation: '',
    descriptionOfDecon: '',
    typeOfEquipments: [],
    typeOfPPEs: [],
    protectionFactor: '',
    numberOfShowerStalls: '',
    reading: '',
    projectName: '',
    project: '',
    leadInfoSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    name: '',
    workerId: '',
    jobTitle: '',
    date: null
}

const LeadInfoSheet = (props) => {
    const iframeRef = useRef();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const { jobFormId, edit } = useParams();
    const [loading, setLoading] = useState(false);
    const [leadInfoSheet, setLeadInfoSheet] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState([]);
    const [hideCOMonitor, setHideCOMonitor] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [switchMode, setSwitchMode] = useState(false);

    const [optionList, setOptionList] = useState({
        blasting: ['Dry', 'Pressure Washing', 'Slurry'],
        powerTooling: ['Grinder', 'Buffer', 'Needle Gun', 'Shroud', 'Grinder w/shroud', 'Buffer w/shroud'],
        handTooling: ['Hand Tool(s)', 'Cleanup', 'Chemical Stripper'],
        enclosureMaterial: ['Poly', 'Cloth', 'Sand Tarp', 'Drop Cloth'],
        enclosureType: ['Full', 'Full/Vented', 'Partial'],
        typeOfVentilation: ['Neg Air', 'Copus Fan', 'Dust Sock'],
        elevationOfProject: ['Ground Level', 'On Scaffold', 'On Deck'],
        typeOfDecontaminationUnit: ['Trailer', 'Free Standing', 'Hand & Eye Wash Station'],
        deconLocation: ['Attached to Enclosure', 'Not Attached to Enclosure'],
        reading: ['Clear', 'Deny'],
        protectionFactor: [{ index: 10, name: '1/2 Face Air Purifying' }, { index: 50, name: 'Full Face Air Purifying' },
        { index: 100, name: 'PAPR w/ Loose Hemet or Hood' }, { index: 1000, name: 'PAPR w/ Fitted Helmet & HEPA Filter' }],
        typeOfEquipments: [
            { name: 'Blast Pot', make: '', model: '' },
            { name: 'Air Compressor', make: '', model: '' },
            { name: 'Dust Collector', make: '', model: '' },
            { name: 'Carbon Monitor', make: '', model: '' },
            { name: 'Air Dryer', make: '', model: '' },
            { name: 'Generator', make: '', model: '' },
            { name: 'Cabinet', make: '', model: '' }
        ],
        typeOfPPEs: [
            { name: 'Blast Hood', make: '', model: '' },
            { name: 'Tyvek Suit', make: '', model: '' },
            { name: 'Face-Shield', make: '', model: '' },
            { name: 'Goggles', make: '', model: '' },
            { name: 'Respirator', make: '', model: '' },
            { name: 'CO Monitor', make: '', model: '' }
        ]
    });

    const [selectedOptions, setSelectedOptions] = useState({
        blasting: null,
        powerTooling: null,
        handTooling: null,
        enclosureMaterial: null,
        enclosureType: null,
        typeOfVentilation: null,
        elevationOfProject: null,
        typeOfDecontaminationUnit: null,
        deconLocation: null,
        protectionFactor: null,
        typeOfEquipments: null,
        typeOfPPEs: null,
        reading: null
    });

    const [lineItemOptions, setLineItemOptions] = useState({
        jobTitle: ['Project Manager', 'Supervisor', 'Worker', 'Air Monitor Helper']
    })
    const [lineItemSelectedOptions, setLineItemSelectedOptions] = useState({
        sampleType: null,
        ppe: null,
        user: null
    })
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [lineItem, setLineItem] = useState(lineItemInitialState);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "Lead Information Sheet",
        actualAssignedDate: null,
        submittedById: 0,
        jobId: 0,
        formLead: '',
        client: '',
        clientAddress: '',
        clientPhoneNumber: ''
    });

    useEffect(() => {
        setLoading(true);
        if (edit == 'false') {
            setSwitchMode(true)
            getReport(jobFormId)
        }
        else {
            fetchJobLocations().then(locations => {
                fetchLeadInfoSheet(locations);
            });
        }
    }, [])

    const getReport = (id) => {
        if (id) {
            leadInfoSheetService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }
    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: leadInfoSheet,
        validationSchema: LeadInfoSheetValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setSubmitting(false)
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: lineItem,
        validationSchema: LeadInfoSheetLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveLineItem(values).finally(() => {
                resetLineItemForm();
                setSubmitting(false)
            });
        }
    });

    const resetLineItemForm = () => {
        formik_lineItem.resetForm();
        setLineItem(lineItemInitialState);
    }

    const saveLineItem = (model) => {
        return leadInfoSheetService.saveLineItem({ ...model, leadInfoSheetId: leadInfoSheet.id, leadInfoSheet: null }).then(res => {
            if (model.id > 0) {
                let temp = [...leadInfoSheet.leadInfoSheetLineItems];
                let indexOfEdited = temp.findIndex(x => x.id === model.id);
                temp[indexOfEdited] = model;
                setLeadInfoSheet({ ...leadInfoSheet, leadInfoSheetLineItems: temp })
            } else {
                setLeadInfoSheet({ ...leadInfoSheet, leadInfoSheetLineItems: [...leadInfoSheet.leadInfoSheetLineItems, { ...model, id: res.id, date: new Date(model.date) }] });
            }

            showAlert({ message: res.message, variant: 'success' });
        });
    }

    const saveForm = (values) => {
        return leadInfoSheetService.save({ ...values, leadInfoSheetLineItems: null, projectLocation: null }).then(res => {
            showAlert({ message: res.message, variant: 'success' });
        });
    }

    const fetchLeadInfoSheet = (projectLocations) => {
        leadInfoSheetService.getLeadInfoSheetById(jobFormId).then(res => {
            if (res.leadInfoSheet.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.leadInfoSheet.projectLocationId));
            }
            setJobForm(res);
            setIsReadOnly(res.submittedById !== 0);
            setLeadInfoSheet({ ...res.leadInfoSheet, typeOfEquipments: res.typeOfEquipments, typeOfPPEs: res.typeOfPPEs });
            populateTypeOfEquipments(res.typeOfEquipments);
            populatePPE(res.typeOfPPEs);
            populateIndexForProtectionFactor(res.leadInfoSheet.protectionFactor);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const populateIndexForProtectionFactor = (factor) => {
        var index = optionList.protectionFactor.find(x => x.name == factor)?.index;
        if (index) {
            setSelectedOptions({ ...selectedOptions, protectionFactor: helper.setToOptionModel(index, index) })
        }
    }

    const submitForm = () => {
        saveForm(formik.values).then(res => {
            jobFormService.submitForm(jobForm.id).then(res => {
                showAlert({ message: res.message, variant: 'success' });
                history.push("/services/manage-job/forms/" + jobForm.jobId);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    const populateTypeOfEquipments = (equipments) => {
        var tempArr = [...optionList.typeOfEquipments];
        if (equipments) {
            equipments.forEach(e => {
                var matchingObjIndex = tempArr.findIndex(y => y.name == e.name);
                if (matchingObjIndex != -1) {
                    tempArr[matchingObjIndex].make = e.make;
                    tempArr[matchingObjIndex].model = e.model;
                }
            });
            setOptionList({ ...optionList, typeOfEquipments: tempArr });
        }
    }

    const populatePPE = (ppe) => {
        var tempArr = [...optionList.typeOfPPEs];
        if (ppe) {
            ppe.forEach(e => {
                if (e.name == 'Blast Hood' && (e.make == 'N/A')) {
                    tempArr = tempArr.filter(x => x.name != 'CO Monitor');
                    setHideCOMonitor(true)
                }
                var matchingObjIndex = tempArr.findIndex(y => y.name == e.name);
                if (matchingObjIndex != -1) {
                    tempArr[matchingObjIndex].make = e.make;
                    tempArr[matchingObjIndex].model = e.model;
                }
            });
            setOptionList({ ...optionList, typeOfPPEs: tempArr });
        }
    }

    const columnOptions = {
        filter: true,
        sort: true,
        print: false,
        download: true
    };

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                display: !isReadOnly,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                            <Button
                                text="Edit"
                                className="info--bg ml-0"
                                size="xxs"
                                onClick={() => {
                                    setLineItem(leadInfoSheet.leadInfoSheetLineItems[dataIndex])
                                }}
                            />

                            <Button
                                text="Delete"
                                className="danger--bg"
                                size="xxs"
                                onClick={() => showConfirmModal({
                                    title: "Delete Line Item",
                                    text: "Are you sure you want to delete this line item?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => removeLineItem(leadInfoSheet.leadInfoSheetLineItems[dataIndex].id)
                                })}
                            />
                        </CustomBlock>
                    )
                }
            }

        },
        {
            name: "name",
            label: "Name",
            options: columnOptions
        },
        {
            name: "workerId",
            label: "Worker Id",
        },
        {
            name: "jobTitle",
            label: "Job Title",
        },
        {
            name: "date",
            label: "Date",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(leadInfoSheet.leadInfoSheetLineItems[dataIndex].date).format("MM/DD/YYYY")}</p>
                    )
                }
            }
        }
    ];

    const removeLineItem = (id) => {
        setLoading();
        setProcessing();
        leadInfoSheetService.deleteLineItem(id).then(res => {
            removeFromLineItemTable(id);
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const removeFromLineItemTable = (id) => {
        let temp = [...leadInfoSheet.leadInfoSheetLineItems];
        let indexOfEdited = temp.findIndex(x => x.id === id);

        if (indexOfEdited > -1) {
            temp.splice(indexOfEdited, 1);
            setLeadInfoSheet({ ...leadInfoSheet, leadInfoSheetLineItems: temp });
        }
    }

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    (
                        <>
                            <Section removeContainer>
                                <ContentBlock>
                                    <CustomBlock className="content-container--card-style--with-shadow">
                                        <ContentHeader
                                            title={`Lead Information Sheet`}
                                            headerSize="md"
                                            primaryButtonText="Print Form"
                                            primaryButtonBackgroundColor="info--bg mr-0"
                                            primaryButtonOnClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        // secondaryButtonText="Save Changes"
                                        // secondaryButtonBackgroundColor="warning--bg"
                                        />

                                        <CustomBlock>
                                            {/* HEADER SECTION */}
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        value={jobForm.projectNumber}
                                                        label="Project Number"
                                                        disabled
                                                    />

                                                </ContentBlock>

                                                {/* <ContentBlock cols={4}>
                                    <InputBlock
                                        value={jobForm.formLead}
                                        label="IH Technician"
                                        disabled
                                    />
                                </ContentBlock> */}
                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Lead Based Paint%"
                                                        name="leadBasedPaintPercentage"
                                                        id="leadBasedPaintPercentage"
                                                        inputState={formik.touched.leadBasedPaintPercentage && formik.errors.leadBasedPaintPercentage ? "error" : ""}
                                                        errorMessage={formik.errors.leadBasedPaintPercentage}
                                                        {...formik.getFieldProps("leadBasedPaintPercentage")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Date"
                                                        disabled
                                                        value={moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={8}>
                                                    <InputBlock
                                                        label="Client"
                                                        value={jobForm.client}
                                                        disabled
                                                    />
                                                </ContentBlock>


                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Phone Number"
                                                        value={jobForm.clientPhoneNumber}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Address"
                                                        value={jobForm.clientAddress.replace(', ,', ',')}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={8}>
                                                    <InputBlock
                                                        label="Contractor"
                                                        value={jobForm.contractor}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Contractor Phone Number"
                                                        value={jobForm.contractorPhoneNumber}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Contractor Address"
                                                        value={jobForm.contractorAddress}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Project Name"
                                                        value={jobForm.projectName}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Type of Project"
                                                        value={jobForm.project}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <SelectBlock
                                                        label="Location Address"
                                                        inputState={formik.touched.projectLocationId && formik.errors.projectLocationId ? "error" : ""}
                                                        errorMessage={formik.errors.projectLocationId}
                                                        value={selectedLocation}
                                                        options={locationOptions}
                                                        disabled={isReadOnly}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedLocation(selectedOption);
                                                            formik.setFieldValue("projectLocationId", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Amount and Type of Material Being Abated"
                                                        name="abatedAmountAndType"
                                                        disabled={isReadOnly}
                                                        id="abatedAmountAndType"
                                                        inputState={formik.touched.abatedAmountAndType && formik.errors.abatedAmountAndType ? "error" : ""}
                                                        errorMessage={formik.errors.abatedAmountAndType}
                                                        {...formik.getFieldProps("abatedAmountAndType")}
                                                    />
                                                </ContentBlock>
                                                <CustomBlock>
                                                    <ContentHeader
                                                        title={`Type of Project:`}
                                                        headerSize="sm"
                                                    />
                                                    <Section removeContainer className="pb-10">
                                                        <ContentBlock cols={6}>
                                                            <SelectBlock
                                                                isClearable
                                                                creatableSelect
                                                                label="Blasting"
                                                                inputState={formik.touched.blasting && formik.errors.blasting ? "error" : ""}
                                                                errorMessage={formik.errors.blasting}
                                                                value={helper.setToOptionModel(formik.values.blasting, formik.values.blasting)}
                                                                options={optionList.blasting.map(x => helper.setToOptionModel(x, x))}
                                                                onChange={selectedOption => {
                                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                                    setSelectedOptions({ ...selectedOptions, blasting: selectedOption });
                                                                    formik.setFieldValue("blasting", selectedOption.value);
                                                                }}
                                                            />
                                                        </ContentBlock>

                                                        <ContentBlock cols={6}>
                                                            <InputBlock
                                                                label="Type of Blast Media"
                                                                name="typeOfBlastMedia"
                                                                id="typeOfBlastMedia"
                                                                inputState={formik.touched.typeOfBlastMedia && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                                errorMessage={formik.errors.typeOfBlastMedia}
                                                                {...formik.getFieldProps("typeOfBlastMedia")}
                                                            />
                                                        </ContentBlock>

                                                        <ContentBlock cols={6}>
                                                            <SelectBlock
                                                                isClearable
                                                                creatableSelect
                                                                label="Power Tooling"
                                                                inputState={formik.touched.powerTooling && formik.errors.powerTooling ? "error" : ""}
                                                                errorMessage={formik.errors.powerTooling}
                                                                value={helper.setToOptionModel(formik.values.powerTooling, formik.values.powerTooling)}
                                                                options={optionList.powerTooling.map(x => helper.setToOptionModel(x, x))}
                                                                onChange={selectedOption => {
                                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                                    setSelectedOptions({ ...selectedOptions, powerTooling: selectedOption });
                                                                    formik.setFieldValue("powerTooling", selectedOption.value);
                                                                }}
                                                            />
                                                        </ContentBlock>

                                                        <ContentBlock cols={6}>
                                                            <SelectBlock
                                                                isClearable
                                                                creatableSelect
                                                                label="Hand Tooling"
                                                                inputState={formik.touched.handTooling && formik.errors.handTooling ? "error" : ""}
                                                                errorMessage={formik.errors.handTooling}
                                                                value={helper.setToOptionModel(formik.values.handTooling, formik.values.handTooling)}
                                                                options={optionList.handTooling.map(x => helper.setToOptionModel(x, x))}
                                                                onChange={selectedOption => {
                                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                                    setSelectedOptions({ ...selectedOptions, handTooling: selectedOption });
                                                                    formik.setFieldValue("handTooling", selectedOption.value);
                                                                }}
                                                            />
                                                        </ContentBlock>
                                                    </Section>
                                                </CustomBlock>

                                                <CustomBlock>
                                                    <ContentHeader
                                                        title={`Type of Equipment in use:`}
                                                        headerSize="sm"
                                                    />
                                                    <Section removeContainer className="pb-10">
                                                        {optionList.typeOfEquipments.map((x, i) =>
                                                            <>
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        value={x.name}
                                                                        label={'Name:'}
                                                                        disabled
                                                                    />
                                                                </ContentBlock>
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        label={'Make:'}
                                                                        name='make'
                                                                        id={x.make}
                                                                        // inputState={formik.touched.typeOfEquipments && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                                        // errorMessage={formik.errors.typeOfBlastMedia}
                                                                        value={x.make}
                                                                        onChange={(e) => {
                                                                            var tempArr = [...optionList.typeOfEquipments];
                                                                            tempArr[i].make = e.target.value;
                                                                            formik.setFieldValue('typeOfEquipments', [...tempArr]);
                                                                            setOptionList({ ...optionList, typeOfEquipments: tempArr });
                                                                            if (e.target.value === 'N/A') {
                                                                                var tempArr = [...optionList.typeOfEquipments];
                                                                                tempArr[i].model = e.target.value;
                                                                                formik.setFieldValue('typeOfEquipments', [...tempArr]);
                                                                                setOptionList({ ...optionList, typeOfEquipments: tempArr });
                                                                            }
                                                                        }}
                                                                    />
                                                                </ContentBlock>
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        label={'Model:'}
                                                                        name={'model'}
                                                                        id={x.model}
                                                                        // inputState={formik.touched.typeOfEquipments && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                                        // errorMessage={formik.errors.typeOfBlastMedia}
                                                                        value={x.model}
                                                                        onChange={(e) => {
                                                                            var tempArr = [...optionList.typeOfEquipments];
                                                                            tempArr[i].model = e.target.value;
                                                                            formik.setFieldValue('typeOfEquipments', [...tempArr]);
                                                                            setOptionList({ ...optionList, typeOfEquipments: tempArr });
                                                                        }}
                                                                    />
                                                                </ContentBlock>

                                                            </>
                                                        )}
                                                    </Section>
                                                </CustomBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Enclosure Material"
                                                        inputState={formik.touched.enclosureMaterial && formik.errors.enclosureMaterial ? "error" : ""}
                                                        errorMessage={formik.errors.enclosureMaterial}
                                                        value={helper.setToOptionModel(formik.values.enclosureMaterial, formik.values.enclosureMaterial)}
                                                        options={optionList.enclosureMaterial.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, enclosureMaterial: selectedOption });
                                                            formik.setFieldValue("enclosureMaterial", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Enclosure Type"
                                                        inputState={formik.touched.enclosureType && formik.errors.enclosureType ? "error" : ""}
                                                        errorMessage={formik.errors.enclosureType}
                                                        value={helper.setToOptionModel(formik.values.enclosureType, formik.values.enclosureType)}
                                                        options={optionList.enclosureType.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, enclosureType: selectedOption });
                                                            formik.setFieldValue("enclosureType", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Type of Ventilation"
                                                        inputState={formik.touched.typeOfVentilation && formik.errors.typeOfVentilation ? "error" : ""}
                                                        errorMessage={formik.errors.typeOfVentilation}
                                                        value={helper.setToOptionModel(formik.values.typeOfVentilation, formik.values.typeOfVentilation)}
                                                        options={optionList.typeOfVentilation.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, typeOfVentilation: selectedOption });
                                                            formik.setFieldValue("typeOfVentilation", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={3}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Elevation of Project"
                                                        inputState={formik.touched.elevationOfProject && formik.errors.elevationOfProject ? "error" : ""}
                                                        errorMessage={formik.errors.elevationOfProject}
                                                        value={helper.setToOptionModel(formik.values.elevationOfProject, formik.values.elevationOfProject)}
                                                        options={optionList.elevationOfProject.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            if(selectedOption){
                                                                selectedOption.value == 'Ground Level' && formik.setFieldValue("levelOfElevation", "");
                                                            }
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, elevationOfProject: selectedOption });
                                                            formik.setFieldValue("elevationOfProject", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                    <ContentBlock cols={3}>
                                                        <InputBlock
                                                            label={'Level:'}
                                                            name={'levelOfElevation'}
                                                            // inputState={formik.touched.typeOfEquipments && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                            // errorMessage={formik.errors.typeOfBlastMedia}
                                                            inputState={formik.touched.levelOfElevation && formik.errors.levelOfElevation ? "error" : ""}
                                                            errorMessage={formik.errors.levelOfElevation}
                                                            {...formik.getFieldProps("levelOfElevation")}
                                                        />
                                                    </ContentBlock>

                                                <CustomBlock>
                                                    <ContentHeader
                                                        title={`Type of PPE in use:`}
                                                        headerSize="sm"
                                                    />
                                                    <Section removeContainer className="pb-10">
                                                        {optionList.typeOfPPEs.map((x, i) =>
                                                            <>
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        value={x.name}
                                                                        label={'Name:'}
                                                                        disabled
                                                                    />
                                                                </ContentBlock>
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        label={'Make:'}
                                                                        name='make'
                                                                        id={x.make}
                                                                        // inputState={formik.touched.typeOfEquipments && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                                        // errorMessage={formik.errors.typeOfBlastMedia}
                                                                        value={x.make}
                                                                        onChange={(e) => {
                                                                            var tempArr = [...optionList.typeOfPPEs];
                                                                            tempArr[i].make = e.target.value;

                                                                            if (tempArr[i].name == 'Blast Hood'
                                                                                && hideCOMonitor) {
                                                                                var tempArr2 = [...tempArr, { name: 'CO Monitor', make: '', model: '' }];
                                                                                setHideCOMonitor(false)
                                                                                formik.setFieldValue('typeOfPPEs', [...tempArr2]);
                                                                                setOptionList({ ...optionList, typeOfPPEs: [...tempArr2] });
                                                                            }
                                                                            else {
                                                                                if (e.target.value === 'N/A') {
                                                                                    if (tempArr[i].name == 'Blast Hood') {
                                                                                        tempArr = tempArr.filter(x => x.name != 'CO Monitor');
                                                                                        setHideCOMonitor(true);
                                                                                    }
                                                                                    tempArr[i].model = 'N/A';
                                                                                }
                                                                                formik.setFieldValue('typeOfPPEs', [...tempArr]);
                                                                                setOptionList({ ...optionList, typeOfPPEs: tempArr });
                                                                            }
                                                                        }}
                                                                    />
                                                                </ContentBlock>

                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        label={'Model:'}
                                                                        name={'model'}
                                                                        id={x.model}
                                                                        // inputState={formik.touched.typeOfEquipments && formik.errors.typeOfBlastMedia ? "error" : ""}
                                                                        // errorMessage={formik.errors.typeOfBlastMedia}
                                                                        value={x.model}
                                                                        onChange={(e) => {
                                                                            var tempArr = [...optionList.typeOfPPEs];
                                                                            tempArr[i].model = e.target.value;
                                                                            formik.setFieldValue('typeOfPPEs', [...tempArr]);
                                                                            setOptionList({ ...optionList, typeOfPPEs: tempArr });
                                                                        }}
                                                                    />
                                                                </ContentBlock>

                                                            </>
                                                        )}
                                                    </Section>
                                                    <ContentBlock cols={6}>
                                                        <SelectBlock
                                                            isClearable
                                                            creatableSelect
                                                            label="Protection Factor"
                                                            inputState={formik.touched.protectionFactor && formik.errors.protectionFactor ? "error" : ""}
                                                            errorMessage={formik.errors.protectionFactor}
                                                            value={selectedOptions.protectionFactor}
                                                            options={optionList.protectionFactor.map(x => helper.setToOptionModel(x.index, x.index))}
                                                            onChange={selectedOption => {
                                                                selectedOption = selectedOption === null ? [] : selectedOption;
                                                                setSelectedOptions({ ...selectedOptions, protectionFactor: selectedOption });
                                                                formik.setFieldValue("protectionFactor", optionList.protectionFactor.find(x => x.index == selectedOption.value).name);
                                                            }}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={6}>
                                                        <SelectBlock
                                                            isClearable
                                                            creatableSelect
                                                            label="Reading"
                                                            inputState={formik.touched.reading && formik.errors.reading ? "error" : ""}
                                                            errorMessage={formik.errors.reading}
                                                            value={helper.setToOptionModel(formik.values.reading, formik.values.reading)}
                                                            options={optionList.reading.map(x => helper.setToOptionModel(x, x))}
                                                            onChange={selectedOption => {
                                                                selectedOption = selectedOption === null ? [] : selectedOption;
                                                                setSelectedOptions({ ...selectedOptions, reading: selectedOption });
                                                                formik.setFieldValue("reading", selectedOption.value);
                                                            }}
                                                        />
                                                    </ContentBlock>
                                                </CustomBlock>
                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Type of Decontamination Unit"
                                                        inputState={formik.touched.typeOfDecontaminationUnit && formik.errors.typeOfDecontaminationUnit ? "error" : ""}
                                                        errorMessage={formik.errors.typeOfDecontaminationUnit}
                                                        value={helper.setToOptionModel(formik.values.typeOfDecontaminationUnit, formik.values.typeOfDecontaminationUnit)}
                                                        options={optionList.typeOfDecontaminationUnit.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, typeOfDecontaminationUnit: selectedOption });
                                                            formik.setFieldValue("typeOfDecontaminationUnit", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Number of Shower Stalls"
                                                        name="numberOfShowerStalls"
                                                        id="numberOfShowerStalls"
                                                        inputState={formik.touched.numberOfShowerStalls && formik.errors.numberOfShowerStalls ? "error" : ""}
                                                        errorMessage={formik.errors.numberOfShowerStalls}
                                                        {...formik.getFieldProps("numberOfShowerStalls")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Decon Location"
                                                        inputState={formik.touched.deconLocation && formik.errors.deconLocation ? "error" : ""}
                                                        errorMessage={formik.errors.deconLocation}
                                                        value={helper.setToOptionModel(formik.values.deconLocation, formik.values.deconLocation)}
                                                        options={optionList.deconLocation.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, deconLocation: selectedOption });
                                                            formik.setFieldValue("deconLocation", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Description of Decon"
                                                        name="descriptionOfDecon"
                                                        id="descriptionOfDecon"
                                                        inputState={formik.touched.descriptionOfDecon && formik.errors.descriptionOfDecon ? "error" : ""}
                                                        errorMessage={formik.errors.descriptionOfDecon}
                                                        {...formik.getFieldProps("descriptionOfDecon")}
                                                    />
                                                </ContentBlock>
                                            </Section>
                                            {/* LINE ITEM ENTRY */}
                                            <Section removeContainer className="pt-10 pb-10 border-top">
                                                {
                                                    !isReadOnly && <>
                                                        <ContentBlock>
                                                            <ContentHeader
                                                                title="Abatement Personnel Information Entry Form"
                                                                headerSize="sm"
                                                                className="fw-700 pb-15"
                                                                primaryButtonText={(formik_lineItem.values.id > 0 ? "Update" : "Add") + " Line Item"}
                                                                secondaryButtonText={'Clear'}
                                                                primaryButtonOnClick={formik_lineItem.submitForm}
                                                                secondaryButtonOnClick={resetLineItemForm}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                label="Name"
                                                                name="name"
                                                                id="name"
                                                                inputState={formik_lineItem.touched.name && formik_lineItem.errors.name ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.name}
                                                                {...formik_lineItem.getFieldProps("name")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                label="Worker Id"
                                                                type="number"
                                                                name="workerId"
                                                                id="workerId"
                                                                inputState={formik_lineItem.touched.workerId && formik_lineItem.errors.workerId ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.workerId}
                                                                {...formik_lineItem.getFieldProps("workerId")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                label="Job Title"
                                                                name="jobTitle"
                                                                id="jobTitle"
                                                                inputState={formik_lineItem.touched.jobTitle && formik_lineItem.errors.jobTitle ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.jobTitle}
                                                                {...formik_lineItem.getFieldProps("jobTitle")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                type="date"
                                                                label="Date"
                                                                options={{
                                                                    enableTime: false,
                                                                    dateFormat: "m/d/Y",
                                                                }}
                                                                value={moment(formik_lineItem.getFieldProps("date").value).format("MM/DD/YYYY")}
                                                                onChange={date => {
                                                                    formik_lineItem.setFieldValue("date", date[0]);
                                                                }}
                                                            />
                                                        </ContentBlock>
                                                    </>
                                                }

                                                <ContentBlock>
                                                    {/* LINE ITEMS TABLE */}
                                                    <CustomBlock className="content-container--table-container">
                                                        <ContentHeader
                                                            title="Abatement Personnel Information"
                                                            headerSize="md"
                                                            className="fw-700 dark-grey--clr pt-10"
                                                        />

                                                        <MUIDataTable
                                                            data={leadInfoSheet.leadInfoSheetLineItems}
                                                            columns={columns}
                                                            options={{
                                                                selectableRows: "none",
                                                                download: true,
                                                                print: false,
                                                            }}
                                                        />
                                                    </CustomBlock>
                                                </ContentBlock>
                                            </Section>

                                            {/* ACTIONS */}
                                            {
                                                !auth.isAdmin ?
                                                    !isReadOnly &&
                                                    <Section removeContainer className="pt-10">
                                                        <ContentBlock className="content-container--actions">
                                                            <Button
                                                                text="Save Changes"
                                                                className="warning--bg"
                                                                onClick={formik.submitForm}
                                                            />

                                                            <Button
                                                                text="Submit Form"
                                                                onClick={submitForm}
                                                                className="success--bg"
                                                            />
                                                        </ContentBlock>
                                                    </Section>
                                                    :
                                                    <Section removeContainer className="pt-10">
                                                        <ContentBlock className="content-container--actions">
                                                            <Button
                                                                text="Save Changes"
                                                                className="warning--bg"
                                                                onClick={formik.submitForm}
                                                            />

                                                            <Button
                                                                text="Submit Form"
                                                                onClick={submitForm}
                                                                className="success--bg"
                                                            />
                                                        </ContentBlock>
                                                    </Section>
                                            }
                                        </CustomBlock>
                                    </CustomBlock>
                                </ContentBlock>
                            </Section >
                        </>
                    )
            }
        </>
    )
}
const mapStateToProps = (state) => ({
    auth: state.auth
})
export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(LeadInfoSheet);